import React, { useState } from 'react';
import AdminSidebar, { AdminPage, AdminSection } from './AdminSidebar';
import { getAdminTheme } from './adminTheme';

interface AdminLayoutProps {
  isDarkMode: boolean;
  title: string;
  breadcrumb?: string;
  onLogout?: () => void;
  sidebar: {
    expanded: Record<AdminSection, boolean>;
    activePage: AdminPage;
    onToggleSection: (section: AdminSection) => void;
    onSelectPage: (page: AdminPage) => void;
  };
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ isDarkMode, title, breadcrumb, onLogout, sidebar, children }) => {
  const [menuSearch, setMenuSearch] = useState('');
  const theme = getAdminTheme(isDarkMode);

  return (
    <div id="admin-layout" style={{ display: 'flex', minHeight: '100vh', backgroundColor: theme.pageBg }}>
      <AdminSidebar
        isDarkMode={isDarkMode}
        expanded={sidebar.expanded}
        activePage={sidebar.activePage}
        onToggleSection={sidebar.onToggleSection}
        onSelectPage={sidebar.onSelectPage}
        side="left"
        searchQuery={menuSearch}
        onSearchQueryChange={setMenuSearch}
      />

      <div id="admin-main" style={{ flex: 1, minWidth: 0 }}>
        <div
          id="admin-topbar"
          style={{
            height: 56,
            backgroundColor: theme.cardBg,
            borderBottom: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            boxSizing: 'border-box',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div id="admin-topbar-title" style={{ fontWeight: 800, color: theme.text }}>
              Admin
            </div>
            <div id="admin-topbar-breadcrumb" style={{ fontSize: 13, color: theme.subText }}>
              {breadcrumb ?? 'Home / Dashboard'}
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: theme.subText, fontSize: 13 }}>
            {onLogout ? (
              <button
                onClick={onLogout}
                style={{
                  height: 32,
                  padding: '0 10px',
                  borderRadius: theme.radius,
                  border: `1px solid ${theme.border}`,
                  backgroundColor: theme.cardBg,
                  color: theme.text,
                  fontWeight: 800,
                  cursor: 'pointer',
                }}
              >
                Logout
              </button>
            ) : null}
          </div>
        </div>

        <div id="admin-content" style={{ maxWidth: 1600, margin: '0 auto', padding: 16, boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 14 }}>
            <div id="admin-page-title" style={{ fontSize: 26, fontWeight: 800, color: theme.text }}>
              {title}
            </div>
            <div id="admin-breadcrumb" style={{ fontSize: 13, color: theme.subText }}>
              {breadcrumb ?? 'Home / Dashboard'}
            </div>
          </div>

          <div id="admin-page">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
